import React, { useMemo } from "react";
import { Helmet } from "react-helmet";
import { Script } from "gatsby";
import { getBoolFromVar } from "@parallelpublicworks/clf-utils";

export default function Root({ children, options }) {
	const version = options.version || Math.random();
	const isProduction = process.env.CLF_ENV === "production";

	const css_cdns = useMemo(() => {
		const _cdns = [];
		if (isProduction && options.customScripts) {
			options.customScripts.forEach(({ cdns }) => {
				if (cdns) {
					cdns.forEach((cdn, index) => {
						if (cdn.src.includes(".css")) {
							_cdns.push(
								<link
									key={`css-custom-${index}-${version}`}
									rel="stylesheet"
									href={`${cdn.src}?v=${version}`}
								/>
							);
						}
					});
				}
			});
		}
		return _cdns;
	}, []);

	const scripts = useMemo(() => {
		if (isProduction && options.customScripts) {
			return options.customScripts.map((item) => {
				const cdnJsObj = item.cdns?.find(
					(cdn) => typeof cdn === "object" && cdn.src && cdn.src.endsWith(".js")
				);
				const cdnJs = cdnJsObj?.src;
				const globalVar = cdnJsObj?.globalVar;

				if (cdnJs) {
					return (
						<React.Fragment key={item.id}>
							<Script src={`${cdnJs}?v=${version}`} strategy="post-hydrate" />
							{globalVar ? (
								<Script strategy="post-hydrate">{`
                                (function waitForGlobal(){
                                    if (window['${globalVar}']) {
                                        ${item.script}
                                    } else {
                                        setTimeout(waitForGlobal, 50);
                                    }
                                })();
                            `}</Script>
							) : (
								<Script strategy="post-hydrate">{item.script}</Script>
							)}
						</React.Fragment>
					);
				}
				return <Script key={item.id}>{item.script}</Script>;
			});
		} else {
			return null;
		}
	}, []);

	return (
		<React.Fragment>
			<Helmet
				htmlAttributes={{
					lang: "en",
				}}
			>
				<meta
					name="viewport"
					content="minimum-scale=1, initial-scale=1, width=device-width"
				/>
				{!getBoolFromVar(process.env.CLF_WHITELABEL) && options.style && (
					<link rel="stylesheet" href={`${options.style}?v=${version}`} />
				)}
				{css_cdns}
			</Helmet>
			{scripts}
			{children}
		</React.Fragment>
	);
}
